/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-05-07 14:30:20
 * @Description: 
 */
/**
 * 定制 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const custommade = {
    // 列表
    list (params) {
        return axios.get(api + 'custommade/list', { params: params })
    },
    // 添加
    review (params) {
        return axios.post(api + 'custommade/review', qs.stringify(params))
    },
    // 详情
    detail (params) {
        return axios.post(api + 'custommade/detail', qs.stringify(params))
    },
    // 推荐
    isRecommend (params) {
        return axios.post(api + 'custommade/isRecommend', qs.stringify(params))
    },
    sort (params) {
        return axios.post(api + 'custommade/sort', qs.stringify(params))
    },
    // 添加
    create (params) {
        return axios.post(api + 'custommade/create', qs.stringify(params))
    },
    // 修改
    edit (params) {
        return axios.post(api + 'custommade/edit', qs.stringify(params))
    },
    // 修改价格和购买状态
    price (params) {
        return axios.post(api + 'custommade/price', qs.stringify(params))
    },
    // 删除
    remove (params) {
        return axios.post(api + 'custommade/remove', qs.stringify(params))
    },
    // 删除用户定价
    removeuserprice (params) {
        return axios.post(api + 'custommade/removeuserprice', qs.stringify(params))
    },

}

// 导出接口
export default custommade
